<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: {
    show: Boolean,
    data: Object,
    mode: {
      type: String,
      default: "add",
    },
    submitting: Boolean
  },

  emits: ['update:submitting', 'finish'],

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      form: {
        id_dashboard: null,
        nama_dashboard: "",
        link_dashbaord: "",
        akses_role: [],
      },

      listOptions: [],

    };
  },

  watch: {
    modalShow(val) {
      if (val) {
        // 👉 modal OPENED
        if (this.mode === "edit" && this.data) {
          this.form.id_dashboard = this.data.id_dashboard;
          this.form.nama_dashboard = this.data.nama_dashboard;
          this.form.link_dashboard = this.data.link_dashboard;

          const selectedIds = this.data.akses_role
            ? this.data.akses_role.split(',').map(i => Number(i.trim()))
            : [];

          this.form.akses_role = this.listOptions.filter(opt =>
            selectedIds.includes(opt.value)
          );
        } else {
          this.resetForm();
        }
      } else {
        // 👉 modal CLOSED
        this.resetForm();
      }
    }
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },

  mounted() {
    this.loadListOptionRole();
  },

  methods: {
    resetForm() {
      this.form.id_dashboard = null
      this.form.nama_dashboard = ""
      this.form.link_dashboard = ""
      this.form.akses_role = []
    },

    loadListOptionRole() {
      let config = {
        method: 'get',
        url: this.BACKEND_URL_VERSION + 'master/roles/getAllroles',
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      }
      axios(config).then((res) => {
        console.log(res)
        const rows = res.data?.data || []

        this.listOptions = rows.map(item => ({
          value: Number(item.id_role),
          label: item.role_name
        }))

        // mode edit
        if (this.mode === "edit" && this.data) {
          const selectedIds = this.data.akses_role
            ? this.data.akses_role.split(',').map(i => Number(i.trim()))
            : [];

          this.form.akses_role = this.listOptions.filter(opt =>
            selectedIds.includes(opt.value)
          );
        }
      }).catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: err.response?.data?.data?.message || "Terjadi kesalahan.",
        });
      });
    },

    async store() {
      if (this.submitting) return;

      if (!this.form.nama_dashboard || !this.form.link_dashboard) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Beberapa field tidak boleh kosong.",
        });
        return;
      }

      const url = this.BACKEND_URL_VERSION + "master/dashboard/";
      const method = this.mode === "edit" ? "put" : "post";

      const payload = {
        ...this.form,
        akses_role: this.form.akses_role.map(item => item.value)
      };

      this.$emit('update:submitting', true);

      try {
        const res = await axios({
          method,
          url,
          data: payload,
          headers: { Authorization: `Bearer ${localStorage.access_token}` },
        });

        console.log(res);

        Swal.fire({
          icon: "success",
          title: "Berhasil",
          text:
            this.mode === "edit"
              ? "Data berhasil diperbarui"
              : "Data berhasil disimpan",
          timer: 1500,
          showConfirmButton: false,
        });

        this.$emit("close");   // ✅ keep your old way
        this.$emit("finish");

      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: err.response?.data?.data?.message || "Terjadi kesalahan.",
        });
      } finally {
        this.$emit('update:submitting', false); // 🔥 now correct timing
      }
    }
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    title="Tambah / Edit Dashboard"
    size="md"
    hide-footer
  >
    <b-form @submit.prevent="store">
      <b-form-group label="Nama Dashboard" class="fw-medium">
        <b-form-input v-model="form.nama_dashboard"></b-form-input>
      </b-form-group>

      <b-form-group label="Link Dashboard" class="fw-medium">
        <b-form-input v-model="form.link_dashboard"></b-form-input>
      </b-form-group>

      <label for="akses_role">Pilih Role</label>
      <v-select        
        v-model="form.akses_role"
        placeholder="Pilih Role"
        class="style-chooser"
        :options="listOptions"
        :multiple="true"
        id="akses_role"
      ></v-select>

      <div class="text-end mt-3">
        <b-button variant="secondary" class="me-2" @click="$emit('close')">
          Batal
        </b-button>
        <b-button type="submit" variant="primary"> Simpan </b-button>
      </div>
    </b-form>
  </b-modal>
</template>